// Keep existing sessions when the rebuilt frontend is deployed on the same site.
export function readStorage(key, fallback = "") {
  try {
    const value = localStorage.getItem(key);
    return value === null ? fallback : JSON.parse(value);
  } catch {
    return localStorage.getItem(key) ?? fallback;
  }
}
export function writeStorage(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}
export function removeStorage(key) {
  localStorage.removeItem(key);
}
export function currentUid() {
  return String(readStorage("userInfo", null)?.id || "");
}
export function clearSession() {
  for (const key of Object.keys(localStorage)) {
    if (
      /^(id|userInfo|token|uid|openid|unionid|loginRedirect|wxfid|homeMerchant)$|^wx|wechat|oauth/i.test(
        key,
      )
    )
      localStorage.removeItem(key);
  }
  for (const key of Object.keys(sessionStorage))
    if (/wechat|oauth|wxUser|login/i.test(key)) sessionStorage.removeItem(key);
  window.dispatchEvent(new Event("session-cleared"));
}
